import React from 'react';
import { IOldIconProps } from './type';

const Information: React.FC<IOldIconProps> = ({ width, height, ...props }) => {
  return (
    <svg
      width={width || 28}
      height={height || 28}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14Z"
        fill="#FFCB03"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 26.4C20.8483 26.4 26.4 20.8483 26.4 14C26.4 7.15167 20.8483 1.6 14 1.6C7.15167 1.6 1.6 7.15167 1.6 14C1.6 20.8483 7.15167 26.4 14 26.4ZM14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z"
        fill="black"
      />
      <path
        d="M15.2188 7.90625C15.2188 8.57935 14.6731 9.125 14 9.125C13.3269 9.125 12.7812 8.57935 12.7812 7.90625C12.7812 7.23315 13.3269 6.6875 14 6.6875C14.6731 6.6875 15.2188 7.23315 15.2188 7.90625Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8187 7.90625C16.8187 9.463 15.5568 10.725 14 10.725C12.4432 10.725 11.1812 9.463 11.1812 7.90625C11.1812 6.3495 12.4432 5.0875 14 5.0875C15.5568 5.0875 16.8187 6.3495 16.8187 7.90625ZM14 9.125C14.6731 9.125 15.2188 8.57935 15.2188 7.90625C15.2188 7.23315 14.6731 6.6875 14 6.6875C13.3269 6.6875 12.7812 7.23315 12.7812 7.90625C12.7812 8.57935 13.3269 9.125 14 9.125Z"
        fill="black"
      />
      <path
        d="M12.7812 14.4187C12.7812 13.7457 13.3269 13.2 14 13.2C14.6731 13.2 15.2188 13.7457 15.2188 14.4187V19.9813C15.2188 20.6543 14.6731 21.2 14 21.2C13.3269 21.2 12.7812 20.6543 12.7812 19.9813V14.4187Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8187 14.4187V19.9813C16.8187 21.538 15.5568 22.8 14 22.8C12.4432 22.8 11.1812 21.538 11.1812 19.9813V14.4187C11.1812 12.862 12.4432 11.6 14 11.6C15.5568 11.6 16.8187 12.862 16.8187 14.4187ZM14 13.2C13.3269 13.2 12.7812 13.7457 12.7812 14.4187V19.9813C12.7812 20.6543 13.3269 21.2 14 21.2C14.6731 21.2 15.2188 20.6543 15.2188 19.9813V14.4187C15.2188 13.7457 14.6731 13.2 14 13.2Z"
        fill="black"
      />
    </svg>
  );
};

export default Information;
